import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const GallerySelectUploadListIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={56} height={56} viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeWidth="0.5">
        <path
          d="M2 12c0-4.714 0-7.071 1.464-8.536C4.93 2 7.286 2 12 2c4.714 0 7.071 0 8.535 1.464C22 4.93 22 7.286 22 12c0 4.714 0 7.071-1.465 8.535C19.072 22 16.714 22 12 22s-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12Z"/>
        <circle cx="16" cy="8" r="2"/>
        <path strokeLinecap="round"
              d="m2 12.5l1.752-1.533a2.3 2.3 0 0 1 3.14.105l4.29 4.29a2 2 0 0 0 2.564.222l.299-.21a3 3 0 0 1 3.731.225L21 18.5"/>
      </g>
    </SvgIcon>
  );
};

